// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectTwoToneSvg from "@ant-design/icons-svg/es/asn/MoneyCollectTwoTone";
import AntdIcon from '../components/AntdIcon';

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectTwoToneSvg
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
export default React.forwardRef(MoneyCollectTwoTone);